export default function addGoogleAdOnIngridTopBanner(items, aNoOfProdsPerRow) {
  const googleAdOnIngridTopItem = {
    googleAdOnIngridTopBanner: {},
    fullWidth: true,
    excludeRow: true,
  };

  const startIndex = aNoOfProdsPerRow * 2;
  return [
    ...items.slice(0, startIndex),
    googleAdOnIngridTopItem,
    ...items.slice(startIndex),
  ];
}
